module.exports = __webpack_public_path__ + "static/img/1.b119dec.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/1/1.png
// module id = ojCe
// module chunks = 0